import React from "react";
import styled from "styled-components";

const ContentHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: ${p => p.gap || "1rem"};
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth || "98.625rem"};
    margin: ${p => p.margin || "1rem 0 1rem"};
    padding: 0.9rem 1rem;
    box-sizing: border-box;
    background: var(--calendar-surface, #ffffff);
    border: 1px solid var(--calendar-border, #d8deec);
    border-radius: 16px;
    box-shadow: var(--calendar-shadow, 0 18px 36px rgba(29, 42, 89, 0.08));

    @media (max-width: 900px) {
        align-items: stretch;
        flex-direction: column;
        flex-wrap: wrap;
        margin-top: 1.25rem;
    }
`;

const HeaderText = styled.div`
    min-width: 0;
    flex: 1;
`;

const HeaderTitle = styled.h1`
    color: ${p => p.color || "var(--calendar-text, #171A22)"};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: ${p => p.size || "2rem"};
    line-height: 1.15;
    font-weight: 800;
    margin: 0;
    max-width: ${p => p.maxWidth || "43.125rem"};

    @media (max-width: 600px) {
        font-size: 1.75rem;
    }
`;

const HeaderDescription = styled.p`
    width: 100%;
    color: ${p => p.color || "var(--calendar-text-muted, #6A7387)"};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: ${p => p.size || "0.875rem"};
    line-height: 1.5;
    font-weight: 500;
    margin: 0.5rem 0 0;
    max-width: ${p => p.maxWidth || "42rem"};
`;

const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.75rem;

    @media (max-width: 900px) {
        justify-content: flex-start;

        > * {
            max-width: 100%;
        }
    }
`;

const ContentHeader = (props) => {
    const { title, titleStyle, description, descriptionStyle, children } = props;

    return (
        <ContentHeaderContainer
            maxWidth={props.maxWidth}
            margin={props.margin}
        >
            <HeaderText>
                <HeaderTitle
                    size={titleStyle && titleStyle["size"] ? titleStyle["size"] : undefined}
                    color={titleStyle && titleStyle["color"] ? titleStyle["color"] : undefined}
                    maxWidth={titleStyle && titleStyle["maxWidth"] ? titleStyle["maxWidth"] : undefined}
                >
                    {title}
                </HeaderTitle>
                {description && (
                    <HeaderDescription
                        size={descriptionStyle && descriptionStyle["size"] ? descriptionStyle["size"] : undefined}
                        color={descriptionStyle && descriptionStyle["color"] ? descriptionStyle["color"] : undefined}
                        maxWidth={descriptionStyle && descriptionStyle["maxWidth"] ? descriptionStyle["maxWidth"] : undefined}
                    >
                        {description}
                    </HeaderDescription>
                )}
            </HeaderText>

            {children && <HeaderControls>{children}</HeaderControls>}
        </ContentHeaderContainer>
    );
};

export default ContentHeader;
